export enum IrisitySystems {
    ManagePortal = 0,
    CustomerApp = 1,
    CarePortal = 2,
    ClientManager = 3,
    KpiApp = 4,
}
